var map = {
	"./App": 9418,
	"./App.vue": 9418,
	"./assets/crisisIcon.svg": 6438,
	"./assets/expand_more.svg": 8378,
	"./assets/icons/logo-dark.svg": 7571,
	"./assets/icons/logo-light.svg": 4361,
	"./assets/icons/moon.svg": 7628,
	"./assets/icons/sun.svg": 7391,
	"./assets/images/0_HomePage/img1.jpg": 1831,
	"./assets/images/0_HomePage/img2.jpg": 8984,
	"./assets/images/0_HomePage/img3.jpg": 165,
	"./assets/images/Ancient/Apelles.png": 2158,
	"./assets/images/Ancient/Parrhasius.png": 492,
	"./assets/images/Ancient/Phidias.png": 7154,
	"./assets/images/Ancient/Zeusi.jpg": 4014,
	"./assets/images/articles/image1.png": 9315,
	"./assets/images/articles/image2.png": 6104,
	"./assets/images/articles/image3.png": 2401,
	"./assets/images/default-image.png": 4972,
	"./assets/map/World_map_blank_without_borders.svg": 2344,
	"./assets/podcasts/brodsky.mp3": 1189,
	"./assets/schoolsIcon.svg": 2906,
	"./assets/search.svg": 8246,
	"./assets/subperiodsIcon.svg": 4385,
	"./assets/transitionIcon.svg": 2716,
	"./components/ArticlesPage/ArticleDetail": 5785,
	"./components/ArticlesPage/ArticleDetail.vue": 5785,
	"./components/ArticlesPage/ArticleList": 1606,
	"./components/ArticlesPage/ArticleList.vue": 1606,
	"./components/ArtistsPage/ArtistList": 5479,
	"./components/ArtistsPage/ArtistList.vue": 5479,
	"./components/FooterApp": 321,
	"./components/FooterApp.vue": 321,
	"./components/GalleryPage/GalleryApp": 5812,
	"./components/GalleryPage/GalleryApp.vue": 5812,
	"./components/HeaderApp": 2949,
	"./components/HeaderApp.vue": 2949,
	"./components/HomePage/AboutApp": 879,
	"./components/HomePage/AboutApp.vue": 879,
	"./components/HomePage/HomePage": 4873,
	"./components/HomePage/HomePage.vue": 4873,
	"./components/HomePage/ImageSlider": 8837,
	"./components/HomePage/ImageSlider.vue": 8837,
	"./components/MapPage/MapApp": 5149,
	"./components/MapPage/MapApp.vue": 5149,
	"./components/NodesPage/ArtistDisplay": 4856,
	"./components/NodesPage/ArtistDisplay.vue": 4856,
	"./components/NodesPage/BezierPaths": 614,
	"./components/NodesPage/BezierPaths.vue": 614,
	"./components/NodesPage/EpochDisplay": 4371,
	"./components/NodesPage/EpochDisplay.vue": 4371,
	"./components/NodesPage/InteractionPanel": 1850,
	"./components/NodesPage/InteractionPanel.vue": 1850,
	"./components/NodesPage/NodesApp": 3081,
	"./components/NodesPage/NodesApp.vue": 3081,
	"./components/PodcastsPage/PodcastList": 1655,
	"./components/PodcastsPage/PodcastList.vue": 1655,
	"./components/PodcastsPage/PodcastPlayer": 1025,
	"./components/PodcastsPage/PodcastPlayer.vue": 1025,
	"./components/ProfilePage/ProfileApp": 4737,
	"./components/ProfilePage/ProfileApp.vue": 4737,
	"./components/TimelinePage/ArtTimeline": 46,
	"./components/TimelinePage/ArtTimeline.vue": 46,
	"./components/TimelinePage/TimelineSubItem": 9628,
	"./components/TimelinePage/TimelineSubItem.vue": 9628,
	"./components/VideosPage/VideoDetail": 5172,
	"./components/VideosPage/VideoDetail.vue": 5172,
	"./components/VideosPage/VideoList": 6166,
	"./components/VideosPage/VideoList.vue": 6166,
	"./data/articles": 5909,
	"./data/articles.json": 5909,
	"./data/artists-by-specialization-and-period-english": 89,
	"./data/artists-by-specialization-and-period-english.json": 89,
	"./data/gallery": 3908,
	"./data/gallery.json": 3908,
	"./data/map-points": 6616,
	"./data/map-points.json": 6616,
	"./data/podcasts": 4423,
	"./data/podcasts.json": 4423,
	"./data/timelineData": 8881,
	"./data/timelineData.js": 8881,
	"./main": 1406,
	"./main.js": 1406,
	"./plugins/theme": 5181,
	"./plugins/theme.js": 5181,
	"./plugins/vuetify": 4174,
	"./plugins/vuetify.js": 4174,
	"./router": 9325,
	"./router/": 9325,
	"./router/index": 9325,
	"./router/index.js": 9325,
	"./store": 5129,
	"./store/": 5129,
	"./store/index": 5129,
	"./store/index.js": 5129,
	"./utils/youtube": 6400,
	"./utils/youtube.js": 6400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;